import React from 'react';
import { LocationSection } from '../components/LocationSection';
export function LocationsPage() {
  return <div data-id="element-824">
      {/* Page Header */}
      <div className="relative py-24 px-4 sm:px-6 lg:px-8 text-center overflow-hidden bg-black" data-id="element-825">
        <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-826" />
        <div className="relative z-10" data-id="element-827">
          <p className="text-[#822433] font-bold text-sm uppercase tracking-widest mb-3" style={{
          color: '#CC0000'
        }} data-id="element-828">
            DMV Area
          </p>
          <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-829">
            Our Locations
          </h1>
          <div className="w-12 h-0.5 mx-auto mt-4 mb-4" style={{
          background: '#FECB00'
        }} data-id="element-830" />
          <p className="text-gray-400 text-base max-w-xl mx-auto" data-id="element-831">
            Three convenient locations across Maryland — all open 24 hours,
            every day.
          </p>
        </div>
      </div>
      <LocationSection data-id="element-832" />
    </div>;
}